// Thin wrappers around /api/tpl — the App Templates library surfaces
// (backend/modules/templates). Server-side gated: every call requires
// platform_admin. The library is a platform-wide artifact store, so no org
// membership grants access to it.
import { fetchData } from '../fetchapi/fetchapi';

export async function templatesOverview() {
  const res = await fetchData('tpl/overview');
  return res.templates || [];
}

export async function exportTemplate(projectSlug, viewName, { template_slug, version, title, contract } = {}) {
  return fetchData('tpl/export', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ project_slug: projectSlug, view_name: viewName, template_slug, version, title, contract }),
  });
}

export async function templateReadiness(templateSlug, projectSlug) {
  return fetchData(`tpl/${encodeURIComponent(templateSlug)}/readiness?project_slug=${encodeURIComponent(projectSlug)}`);
}

export async function installTemplate(templateSlug, projectSlug, version) {
  return fetchData('tpl/install', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ template_slug: templateSlug, project_slug: projectSlug, version: version || undefined }),
  });
}

export async function pinTemplateInstall(templateSlug, projectSlug, pinned) {
  return fetchData('tpl/pin', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ template_slug: templateSlug, project_slug: projectSlug, pinned }),
  });
}

export async function mintDeployCredential(templateSlug, projectSlug) {
  return fetchData('tpl/deploy-credential', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ template_slug: templateSlug, project_slug: projectSlug }),
  });
}

export async function revokeDeployCredential(clientId, { purge = false } = {}) {
  return fetchData(`tpl/deploy-credential/${encodeURIComponent(clientId)}${purge ? '?purge=1' : ''}`, { method: 'DELETE' });
}

export async function assignTemplate(templateSlug, orgSlug, projectSlug) {
  return fetchData('tpl/assign', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ template_slug: templateSlug, org_slug: orgSlug, project_slug: projectSlug || undefined }),
  });
}

export async function unassignTemplate(templateSlug, orgSlug) {
  return fetchData(`tpl/assign?template_slug=${encodeURIComponent(templateSlug)}&org_slug=${encodeURIComponent(orgSlug)}`, { method: 'DELETE' });
}

export async function suspendTemplate(templateSlug, projectSlug) {
  return fetchData('tpl/suspend', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ template_slug: templateSlug, project_slug: projectSlug }),
  });
}

export async function upgradeAllInstalls(templateSlug) {
  return fetchData(`tpl/${encodeURIComponent(templateSlug)}/upgrade-all`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' });
}

export async function uninstallTemplate(templateSlug, projectSlug) {
  return fetchData('tpl/uninstall', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ template_slug: templateSlug, project_slug: projectSlug }),
  });
}

export async function deleteTemplate(templateSlug) {
  return fetchData(`tpl/${encodeURIComponent(templateSlug)}`, { method: 'DELETE' });
}
